<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <h2 data-testid="report-builder-heading">
          {{ (isEditing() ? 'reports.builder.editTitle' : 'reports.builder.title') | translate }}
        </h2>
      </app-card-title>

      <!-- Stepper -->
      <ol class="wizard-steps flex gap-md" data-testid="report-builder-steps" role="tablist">
        @for (titleKey of stepTitleKeys; track titleKey; let i = $index) {
        <li class="wizard-step" [class.active]="step() === i" [class.done]="step() > i">
          <button type="button" class="wizard-step-tab flex flex-align-center gap-sm" role="tab"
            [attr.aria-selected]="step() === i" [disabled]="!canGoToStep(i)"
            [attr.data-testid]="'report-builder-step-' + i" (click)="goToStep(i)">
            <span class="step-number">{{ i + 1 }}</span>
            <span class="step-label">{{ titleKey | translate }}</span>
          </button>
        </li>
        }
      </ol>
    </app-card-header>

    <app-card-content>
      <!-- Steps 1-3: Formly form -->
      @if (step() < 3) {
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields()" [model]="model" (modelChange)="onModelChange()"
          data-testid="report-builder-form" />
      </form>
      } @else {
      <!-- Step 4: Review -->
      <div class="review" data-testid="report-builder-review">
        <h3>{{ 'reports.builder.reviewTitle' | translate }}</h3>
        <ul class="summary-list">
          @for (line of summaryLines(); track line) {
          <li>{{ line }}</li>
          }
        </ul>
      </div>
      }
    </app-card-content>

    <!-- Navigation -->
    <app-card-actions data-testid="report-builder-nav">
      <app-button variant="text" (click)="back()" data-testid="report-builder-back-button">
        <app-icon name="arrow-left" />
        {{ 'reports.builder.back' | translate }}
      </app-button>

      <span class="spacer flex-grow"></span>

      @if (step() > 0) {
      <app-button variant="outlined" (click)="previous()" data-testid="report-builder-prev-button">
        {{ 'reports.builder.previous' | translate }}
      </app-button>
      }

      @if (step() < 3) {
      <app-button variant="filled" (click)="next()" [disabled]="step() === 0 && !canRun()"
        data-testid="report-builder-next-button">
        {{ 'reports.builder.next' | translate }}
        <app-icon name="arrow-right" />
      </app-button>
      } @else {
      @if (canSaveAs()) {
      <app-button variant="text" (click)="saveAs()" [disabled]="saving()"
        *hasPermission="'reports.create'" data-testid="report-builder-save-as-button">
        <app-icon name="copy" />
        {{ 'reports.builder.saveAs' | translate }}
      </app-button>
      }
      <app-button variant="outlined" (click)="save()" [disabled]="!canSave() || saving()"
        *hasPermission="'reports.create'" data-testid="report-builder-save-button">
        @if (saving()) {
        <app-spinner [diameter]="18" />
        } @else {
        <app-icon name="save" />
        }
        {{ (isEditing() ? 'reports.builder.update' : 'reports.builder.save') | translate }}
      </app-button>
      <app-button variant="filled" (click)="run()" [disabled]="!canRun()"
        data-testid="report-builder-run-button">
        <app-icon name="play" />
        {{ 'reports.builder.run' | translate }}
      </app-button>
      }
    </app-card-actions>
  </app-card>
</div>
